import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchFlowNodesCompleteDetails = ({
  cleanRoomID,
  cleanRoomFlowID,
  flowVersion = -1,
  enabled = true,
}) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const {
    isLoading,
    isError,
    isSuccess,
    data,
    refetch,
    isRefetching,
  } = useQuery(
    ['Flow-Nodes-Complete-Details', orgId, cleanRoomID, cleanRoomFlowID, flowVersion],
    async () => axiosInstance.get(
      flow(orgId).nodesCompleteDetails(cleanRoomID, cleanRoomFlowID, flowVersion),
    ),
    {
      enabled: enabled && !!cleanRoomID && !!cleanRoomFlowID && !!orgId,
      refetchOnWindowFocus: false,
      retry: false,
      onSuccess: () => {
        dispatch(showAlert({
          message: 'Flow nodes complete details fetched successfully.',
          type: 'success',
        }));
      },
      onError: (error) => {
        dispatch(showAlert({
          message: error.response?.data?.message || 'Failed to fetch flow nodes complete details',
          type: 'error',
        }));
      },
    },
  );

  return {
    isLoading,
    isError,
    isSuccess,
    data: data?.data,
    refetch,
    isRefetching,
  };
};
